"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Utils = require("player-core/utils");
require("./SearchModule.css");
var Button_1 = require("player-common-controls/controls/Button");
var grid_layout_1 = require("@csod/grid-layout");
var GridCol_1 = require("@csod/grid-layout/build/control/GridCol");
var MultiselectDropdown_1 = require("../MultiselectDropdown/MultiselectDropdown");
var PredictiveSearch_1 = require("../PredictiveSearch/PredictiveSearch");
var dropdown_list_1 = require("@csod/dropdown-list");
var SearchModule = (function (_super) {
    __extends(SearchModule, _super);
    function SearchModule(props) {
        return _super.call(this, props) || this;
    }
    SearchModule.prototype.render = function () {
        var _a = this.props, tag = _a.tag, keywordSearchId = _a.keywordSearchId, keywordSearchValue = _a.keywordSearchValue, keywordSearchPlaceholder = _a.keywordSearchPlaceholder, keywordMaxLength = _a.keywordMaxLength, keywordErrorMessage = _a.keywordErrorMessage, keywordPredictions = _a.keywordPredictions, keywordSearchIsEnabled = _a.keywordSearchIsEnabled, keywordAriaLabel = _a.keywordAriaLabel, keywordSearchResultsPage = _a.keywordSearchResultsPage, keywordNoPredictionsMessage = _a.keywordNoPredictionsMessage, keywordIsLoading = _a.keywordIsLoading, keywordDebounceWait = _a.keywordDebounceWait, keywordDebounceMaxWait = _a.keywordDebounceMaxWait, keywordIconName = _a.keywordIconName, keywordSearchOnChange = _a.keywordSearchOnChange, keywordSearchOnPredict = _a.keywordSearchOnPredict, keywordSearchOnSelect = _a.keywordSearchOnSelect, keywordSearchOnSearch = _a.keywordSearchOnSearch, locationSearchId = _a.locationSearchId, locationSearchValue = _a.locationSearchValue, locationSearchPlaceholder = _a.locationSearchPlaceholder, locationMaxLength = _a.locationMaxLength, locationErrorMessage = _a.locationErrorMessage, locationPredictions = _a.locationPredictions, locationSearchIsEnabled = _a.locationSearchIsEnabled, locationAriaLabel = _a.locationAriaLabel, locationSearchResultsPage = _a.locationSearchResultsPage, locationNoPredictionsMessage = _a.locationNoPredictionsMessage, locationIsLoading = _a.locationIsLoading, locationDebounceWait = _a.locationDebounceWait, locationDebounceMaxWait = _a.locationDebounceMaxWait, locationIconName = _a.locationIconName, locationSearchOnChange = _a.locationSearchOnChange, locationSearchOnPredict = _a.locationSearchOnPredict, locationSearchOnSelect = _a.locationSearchOnSelect, locationSearchOnSearch = _a.locationSearchOnSearch, submitButtonText = _a.submitButtonText, submitButtonTooltip = _a.submitButtonTooltip, submitButtonType = _a.submitButtonType, submitButtonColor = _a.submitButtonColor, submitButtonWidth = _a.submitButtonWidth, submitButtonIconName = _a.submitButtonIconName, submitButtonIsEnabled = _a.submitButtonIsEnabled, submitButtonOnClick = _a.submitButtonOnClick, customFieldDropdownItems = _a.customFieldDropdownItems, customFieldDropdownIsMultiselect = _a.customFieldDropdownIsMultiselect, customFieldDropdownPlaceholderText = _a.customFieldDropdownPlaceholderText, customFieldDropdownMultiselectButtonTextSuffix = _a.customFieldDropdownMultiselectButtonTextSuffix, customFieldDropdownOnChange = _a.customFieldDropdownOnChange, customFieldDropdownIsVisible = _a.customFieldDropdownIsVisible, customFieldDropdownHeight = _a.customFieldDropdownHeight;
        return (React.createElement("div", { className: "p-search-module", "data-tag": tag },
            React.createElement(grid_layout_1.GridLayout, null,
                React.createElement(GridCol_1.GridCol, { width: customFieldDropdownIsVisible ? '4' : '7' },
                    React.createElement("div", { className: "keyword-search" },
                        React.createElement(PredictiveSearch_1.PredictiveSearch, { id: keywordSearchId, value: keywordSearchValue, placeholder: keywordSearchPlaceholder, maxLength: keywordMaxLength, errorMessage: keywordErrorMessage, predictions: keywordPredictions, isEnabled: keywordSearchIsEnabled, ariaLabel: keywordAriaLabel, searchResultsPage: keywordSearchResultsPage, noPredictionsMessage: keywordNoPredictionsMessage, isLoading: keywordIsLoading, debounceWait: keywordDebounceWait, debounceMaxWait: keywordDebounceMaxWait, onChange: keywordSearchOnChange, onPredict: keywordSearchOnPredict, onSelect: keywordSearchOnSelect, onSearch: keywordSearchOnSearch, iconName: keywordIconName }))),
                customFieldDropdownIsVisible && React.createElement(GridCol_1.GridCol, { width: "3" },
                    React.createElement("div", { className: "custom-field-dropdown" },
                        React.createElement(CustomFieldDropdown, { items: customFieldDropdownItems || [], isMultiselect: customFieldDropdownIsMultiselect, placeholderText: customFieldDropdownPlaceholderText || '', buttonTextSuffix: customFieldDropdownMultiselectButtonTextSuffix, onChange: customFieldDropdownOnChange, dropdownHeight: customFieldDropdownHeight }))),
                React.createElement(GridCol_1.GridCol, { width: "3" },
                    React.createElement("div", { className: "location-search" },
                        React.createElement(PredictiveSearch_1.PredictiveSearch, { id: locationSearchId, value: locationSearchValue, placeholder: locationSearchPlaceholder, maxLength: locationMaxLength, errorMessage: locationErrorMessage, predictions: locationPredictions, isEnabled: locationSearchIsEnabled, ariaLabel: locationAriaLabel, searchResultsPage: locationSearchResultsPage, noPredictionsMessage: locationNoPredictionsMessage, isLoading: locationIsLoading, debounceWait: locationDebounceWait, debounceMaxWait: locationDebounceMaxWait, onChange: locationSearchOnChange, onPredict: locationSearchOnPredict, onSelect: locationSearchOnSelect, onSearch: locationSearchOnSearch, iconName: locationIconName }))),
                React.createElement(GridCol_1.GridCol, { width: "2" },
                    React.createElement(Button_1.Button, { text: submitButtonText, toolTip: submitButtonTooltip, type: submitButtonType, color: submitButtonColor, width: submitButtonWidth, iconName: submitButtonIconName, isDisabled: submitButtonIsEnabled, onClick: submitButtonOnClick })))));
    };
    return SearchModule;
}(React.Component));
SearchModule.DefaultProps = {
    keywordSearchId: 'inp' + Utils.createUUID(),
    locationSearchId: 'inp' + Utils.createUUID(),
    submitButtonText: 'Search',
    submitButtonColor: 'Primary',
    submitButtonWidth: 'Block',
    keywordIconName: 'magnifying-glass',
    locationIconName: 'location',
    customFieldDropdownItems: [],
    customFieldDropdownIsMultiselect: false,
    customFieldDropdownPlaceholderText: '',
    customFieldDropdownIsVisible: false,
    customFieldDropdownHeight: null
};
exports.SearchModule = SearchModule;
var CustomFieldDropdown = (function (_super) {
    __extends(CustomFieldDropdown, _super);
    function CustomFieldDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.onSingleSelectChange = _this.onSingleSelectChange.bind(_this);
        _this.onMultiSelectChange = _this.onMultiSelectChange.bind(_this);
        _this.state = {
            items: _this.getItems(props),
        };
        return _this;
    }
    CustomFieldDropdown.prototype.getItems = function (props) {
        var items = [];
        if (!props.isMultiselect) {
            items.push({
                label: props.placeholderText,
                value: '',
                isChecked: false,
            });
        }
        return items.concat(props.items || []);
    };
    CustomFieldDropdown.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({ items: this.getItems(nextProps) });
    };
    CustomFieldDropdown.prototype.onSingleSelectChange = function (val) {
        var onChange = this.props.onChange;
        if (onChange) {
            onChange([val]);
        }
        var items = this.state.items;
        items = (items || []).map(function (item) { return Object.assign({}, item, { isChecked: val === item.value }); });
        this.setState({ items: items });
    };
    CustomFieldDropdown.prototype.onMultiSelectChange = function (selectedItems) {
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(selectedItems.map(function (x) { return x.value; }));
        }
    };
    CustomFieldDropdown.prototype.render = function () {
        var _a = this.props, isMultiselect = _a.isMultiselect, placeholderText = _a.placeholderText, buttonTextSuffix = _a.buttonTextSuffix, dropdownHeight = _a.dropdownHeight;
        var items = this.state.items;
        var selectedValue = '';
        if (!isMultiselect && (items || []).length > 1) {
            var item = (items || []).filter(function (x) { return x.isChecked; })[0];
            selectedValue = item ? item.value : '';
        }
        var className = [];
        if (!selectedValue) {
            className.push('placeholder');
        }
        return (React.createElement("div", { className: className.join(' '), "data-tag": this.props.tag },
            !isMultiselect && React.createElement(dropdown_list_1.DropdownList, { items: items, onChange: this.onSingleSelectChange, value: selectedValue }),
            isMultiselect && React.createElement(MultiselectDropdown_1.default, { items: items, placeholder: placeholderText, buttonTextSuffix: buttonTextSuffix, onChange: this.onMultiSelectChange, dropdownHeight: dropdownHeight })));
    };
    return CustomFieldDropdown;
}(React.Component));
CustomFieldDropdown.defaultProps = {
    tag: null,
    isMultiselect: false,
    placeholderText: '',
    buttonTextSuffix: '',
    dropdownHeight: null
};
exports.CustomFieldDropdown = CustomFieldDropdown;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["SearchModule"] = undefined;


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/SearchModule/SearchModule.js
// module id = 546
// module chunks = 0